import { render } from "./Unlink.vue?vue&type=template&id=ae508f14&scoped=true"
import script from "./Unlink.vue?vue&type=script&lang=js"
export * from "./Unlink.vue?vue&type=script&lang=js"

import "./Unlink.vue?vue&type=style&index=0&id=ae508f14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae508f14"

export default script